export default{
    products:[],
    product: null,
    low_stock_products:[],
    cart:[],
    count:null,
    customers:[],
    users:[],
    suppliers:[],
    categories:[],
    wharehouses:[],
    witems:[],
    transfers:[],
    pos_warehouses:[],
    financial_accounts:[],
    purchases:[],
    expenses:[],
    expense_category:[],
    departments:[],
    personels:[],
    mainchart:[],
    settings:{},

    
    //for sidebars
    sidebarShow: 'responsive',
    sidebarMinimize: false
}